import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'
import { format } from 'date-fns'

import { CurrencyIcon } from '@dfds-frontend/navigator-icons/icons'

import { isSogRoute, mapToCurrencyToContentfulResource } from '../../Utils/sog-helpers'

import { useRoutes } from '../../Hooks/routes/useRoutes'

import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import SelectField from '../shared/SelectField'
import Currency from './Currency'

const CurrencySelector = () => {
  const {
    state: { selectedCurrency, selectedDates },
  } = useTravelSearchContext()
  const { isRoutesLoading, selectedRoute } = useRoutes()
  const { activeField, closeIfActive, toggleField } = useActiveSelectField()
  const { t } = useTranslation()
  const outboundDate = selectedDates?.outboundDate ? format(selectedDates.outboundDate, 'yyyy-MM-dd') : undefined
  return (
    <div
      className={clsx(
        'col-span-12 box-border h-[58px] w-full md:col-span-6 lg:flex-1',
        !isSogRoute(selectedRoute?.routeCode ?? '', outboundDate) && 'hidden'
      )}
    >
      <SelectField
        dataAttrList={[{ name: 'selected-currency', value: `${selectedCurrency}` }]}
        disabled={!isSogRoute(selectedRoute?.routeCode ?? '', outboundDate)}
        fieldName="currency"
        icon={<CurrencyIcon size="md" />}
        isLoading={isRoutesLoading}
        isOpen={activeField === ActiveSelectField.CURRENCY}
        onClick={(clickedOutside: boolean) => {
          !isRoutesLoading && toggleField(ActiveSelectField.CURRENCY, clickedOutside)
        }}
        onClose={() => {
          closeIfActive(ActiveSelectField.CURRENCY)
        }}
        title={t('CURRENCY')}
        value={mapToCurrencyToContentfulResource(selectedCurrency, t)}
      >
        <Currency />
      </SelectField>
    </div>
  )
}

export default CurrencySelector
